import { UploadFile } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import { FileRejection, useDropzone } from 'react-dropzone';

import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { translate } from '@/ui/i18n';
import { ColorsRaw } from '@/ui/theme/colors-raw';

export function DropOrSelectTheGreenShotFile({
  onExcelFileSelected,
}: {
  onExcelFileSelected: (file: File) => void;
}) {
  const onDrop = async (
    acceptedFiles: File[],
    fileRejections: FileRejection[],
  ) => {
    if (fileRejections.length > 0) {
      console.log('fileRejections:', fileRejections);
      return;
    }
    const file = acceptedFiles[0];
    onExcelFileSelected(file);
  };

  const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
    accept: { xlsx: ['.xlsx'] },
    noClick: true,
    noKeyboard: true,
    multiple: false,
    maxFiles: 1,
    onDrop,
  });

  return (
    <Stack sx={{ alignItems: 'center' }}>
      <Stack
        {...getRootProps()}
        sx={{
          p: 4,
          border: '1px dashed',
          borderRadius: '0.5rem',
          borderColor: isDragActive
            ? ColorsRaw.main.Navy_Light
            : ColorsRaw.anthracite.Anthracite_5,
          backgroundColor: isDragActive
            ? ColorsRaw.anthracite.Anthracite_4
            : 'transparent',
          alignItems: 'center',
        }}
      >
        <input {...getInputProps()} />
        <Stack sx={{ alignItems: 'center', gap: 2 }}>
          <Box>
            <UploadFile sx={{ fontSize: '3rem' }} />
          </Box>
          <Typography sx={{ fontSize: '1.5rem', fontWeight: 800 }}>
            {translate('ModalImportAnswers.drop-a-file')}
          </Typography>
          <Typography sx={{ fontSize: '1rem' }}>
            {translate('ModalImportAnswers.or')}
          </Typography>
          <FSPrimaryButton onClick={open} sx={{ mt: 1 }}>
            {translate('ModalImportAnswers.select-a-file')}
          </FSPrimaryButton>
        </Stack>
      </Stack>
    </Stack>
  );
}
